import microuniversoApi from "app/api/microuniversoApi"
import { Desdobramento, DesdobramentoFiltro, ItemNumeroPedidoBloqueioDesdobramento } from "./Desdobramento"
import { useEffect, useRef, useState } from "react"
import React from "react"
import { Vendedor } from "app/types/Vendedor";
import { IFilial } from "app/types/IFilial";
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "app/use-cases";
import { FiltroPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer";
import { Dict } from "app/utils/Dict";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";

declare const window: any;

export type DesdobramentoContainerProps = {
    filtrosDesdobramento: DesdobramentoFiltro
}

export const DesdobramentoContainer = (props: DesdobramentoContainerProps) => {
    const [dadosCarregados, setDadosCarregados] = useState(false)
    const [processando, setProcessando] = useState(false)
    const [filiais, setFiliais] = useState<Partial<IFilial>[]>([])
    const [vendedores, setVendedores] = useState<Vendedor[]>([])
    const [filtrosDesdobramentos, setFiltrosDesdobramentos] = useState<DesdobramentoFiltro>(props.filtrosDesdobramento)
    const [listaDesdobramento, setListaDesdobramento] = useState<Desdobramento[]>([])
    const [orcamentosSelecionados, setOrcamentosSelecionados] = useState([])
    const [senhaLiberacao, setSenhaLiberacao] = useState("")

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())
    const onRenderizarDesdobramento = () => renderizarComponentReact(
        <DesdobramentoContainer
            filtrosDesdobramento={filtrosDesdobramentos}
            />, "desdobramento-region", true
    )
    
    const atualizarOidFilialUsuarioLogado = async () => {
        const CodigoFilialUsuarioLogado = await microuniversoApi.Usuario.ObterCodigoFilialUsuarioLogado()
        setFiltrosDesdobramentos({
            ...filtrosDesdobramentos,
            Filial: CodigoFilialUsuarioLogado
        })
    }

    const listarFiliais = async () => {
        setFiliais(
            await microuniversoApi.Vendedor.listarFiliaisOrcamento()
        )
    }

    const listarVendedores = async (nome?: string) => {
        setVendedores(
            await microuniversoApi.Vendedor.ListarSimplificado("")
        )
    }

    const onPesquisar = async(pagina: number, filtro: DesdobramentoFiltro, clickBotaoPesquisar:boolean) => {
        try {
            setProcessando(true)
            globalMU.blockUI()
            setListaDesdobramento([])
            
            const listaDesdobramento = await microuniversoApi.Desdobramento.PesquisarOrcamentosDesdobramento(filtro)
            setListaDesdobramento(listaDesdobramento)
            setOrcamentosSelecionados([])
        }
        catch (e) {
            tratamentoErroPadrao(e)
        }
        finally {
            globalMU.unblockUI()
            setProcessando(false)
        }
    }

    const onLiberarManut = async(listaNumeroPedido: ItemNumeroPedidoBloqueioDesdobramento[]) => {
        try {
            setProcessando(true)
            globalMU.blockUI()
            if(listaNumeroPedido.length === 0) {
                return false;
            }
            const result = await microuniversoApi.Desdobramento.BloqueiaDesbloqueiaOrcamentoParaManutencao(listaNumeroPedido)
            if (typeof result !== "boolean" && result.HasErrors) {
                return false;
            }
            return result;
        } catch (e) {
            tratamentoErroPadrao(e)
            return false;
        } finally {
            globalMU.unblockUI()
            setProcessando(false)
        }
    }

    const onMarcaDesmarca = async (marcado: boolean, numeroPedido: number) => {
        try {
            setProcessando(true)
            globalMU.blockUI()
            const result = await microuniversoApi.Desdobramento.BloqueiaDesbloqueiaOrcamentoParaManutencao([{
                NumeroPedido: numeroPedido, 
                BloqueiaPedido: marcado
            }])
            if (typeof result !== "boolean" && result.HasErrors) {
                return false;
            }
            return result;
        } catch (e) {
            tratamentoErroPadrao(e)
            return false;
        } finally {
            globalMU.unblockUI()
            setProcessando(false)
        }
    }

    const onConfirmar = async (lista: ItemNumeroPedidoBloqueioDesdobramento[]) => {
        try {
            if (lista.length === 0) {
                globalMU.showErrorMessage("Selecione ao menos um orçamento para confirmar o desdobramento.")
                return false;
            }
            setProcessando(true)
            globalMU.blockUI()
            const result = await microuniversoApi.Desdobramento.ConfirmarDesdobramento({
                listaNumeroPedidoBloqueiaDesdobramento: lista,
                senhaLiberacao: senhaLiberacao
            })
            result == true && globalMU.showSuccessMessage("Desdobramento confirmado com sucesso.")
            return result == true;
        } catch (e) {
            tratamentoErroPadrao(e)
            return false;
        } finally {
            globalMU.unblockUI()
            setProcessando(false)
        }
    }

    const onPesquisarCliente = (filtro: Partial<FiltroPesquisaOrcamento>) => {
        renderizarComponentReact(
            <PesquisarClienteContainer
                regiaoRenderizada="desdobramento-region" passos={passosInterno.current}
                foraOrcamento={true}
                onVoltar={() => onRenderizarDesdobramento()} 
                consultar
                onSelecionarClienteCallback={(cliente) => {
                    
                    renderizarComponentReact(<DesdobramentoContainer
                        filtrosDesdobramento={{
                            ...filtrosDesdobramentos,
                            CodigoCliente: cliente.Codigo,
                            NomeCliente: cliente.Nome
                        }}
                        />, "desdobramento-region", true)
                }}
            />, "desdobramento-region", true)
    }

    useEffect(() => {
        passosInterno.current.set("Desdobramento", () => onRenderizarDesdobramento())
        Promise.all([
            listarFiliais(),
            listarVendedores(),
            filtrosDesdobramentos?.Filial ?? atualizarOidFilialUsuarioLogado(),
        ]).then(() => {
            setDadosCarregados(true)
        })
    }, [])

    useEffect(() => {
        var desdobramentoHub = $.connection.desdobramentoHub
        desdobramentoHub.client.pong = () => {
            console.log('desdobramentoHub => pong')
        }
        $.connection.hub.start().done(function () {
            desdobramentoHub.server.ping()
        })
    }, [])

    return (dadosCarregados &&
        <>
            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={false}
                processando={processando}
                id="DesdobramentoContainer"
            />
        
            <Desdobramento 
                dadosFiltro={{
                    Filiais: filiais,
                    Vendedores: vendedores,
                    DataInicial: null,
                    DataFinal: new Date().toISOString(),
                }}
                filtro={filtrosDesdobramentos}
                onPesquisarCliente={onPesquisarCliente}
                onPesquisar={onPesquisar}
                processandoPesquisa={false}
                onConfirmar={onConfirmar}
                onLiberarManut={onLiberarManut}
                onMarcaDesmarcaProps={onMarcaDesmarca}
                onMarcarTodos={onLiberarManut}
                onDesmarcarTodos={onLiberarManut}
                listaDesdobramento={listaDesdobramento}
                onAtualizaFiltrosNoPai={(filtros) => setFiltrosDesdobramentos(filtros)}
                onChangeSenha={(senha) => setSenhaLiberacao(senha)}
            />
        </>
    )
}

window.DesdobramentoContainer = DesdobramentoContainer